import { inject, Injectable } from '@angular/core';
import { Transaction } from '../types/transaction';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_UNSETTLED_TRANSACTIONS } from '../main.api';

@Injectable()
export class TransactionRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async loadAll(accountId: number): Promise<Transaction[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_UNSETTLED_TRANSACTIONS,
      pathParams: { accountId },
    });
  }
}
